module.exports = __webpack_public_path__ + "static/media/logo_wbs_schulen.02cca0c7.svg";